import React from "react";
import Navbar from "../../../Navbar/Navbar";
import RozhanaMawadTable from "./RozhanaMawadTable";
import { ProductConsumer } from "../../../Context/AddProWakel";
const AllKogaRaport = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            OnHarzantrChange,
            OnCancleHarzantrChange,
            OnHarzantrChange_IQD,
            OnIsSignleReturn,
            onGrantrCHange,
            onGrantrCHange_IQD,
            OnIsSignleGrantrChange
          } = value;
          return (
            <div>
              <Navbar />
              <div style={{ marginTop: "50px" }}>
                <div
                  style={{
                    backgroundColor: "#1a1f2e",
                    padding: "16px 34px",
                    borderBottom: "2px solid #f0ad4e",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "12px"
                  }}
                >
                  <h5
                    className="font-weight-bold text-warning mb-0"
                    style={{ letterSpacing: "1px" }}
                  >
                    ڕاپۆرتی ڕۆژانەی فرۆشتنی کاڵا
                  </h5>
                  <div
                    style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                  >
                    <button
                      onClick={onGrantrCHange}
                      className="btn btn-lg btn-warning font-weight-bold"
                    >
                      $ گرانتر
                    </button>
                    <button
                      onClick={onGrantrCHange_IQD}
                      className="btn btn-lg btn-success font-weight-bold"
                    >
                      IQD گرانتر
                    </button>
                    <button
                      onClick={OnIsSignleGrantrChange}
                      className="btn btn-lg btn-secondary font-weight-bold"
                    >
                     گرانتر دانە 
                    </button>
                    |||||||
                    <button
                      onClick={OnHarzantrChange}
                      className="btn btn-lg btn-warning font-weight-bold"
                    >
                      $ هەرزانتر
                    </button>
                    <button
                      onClick={OnHarzantrChange_IQD}
                      className="btn btn-lg btn-info font-weight-bold"
                    >
                      IQD هەرزانتر
                    </button>
                    <button
                      onClick={OnIsSignleReturn}
                      className="btn btn-lg btn-info font-weight-bold"
                    >
                     هەرزانتر دانە
                    </button>
                    <button
                      onClick={OnCancleHarzantrChange}
                      className="btn btn-lg btn-secondary font-weight-bold"
                    >
                      هەموو
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <RozhanaMawadTable />
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </ProductConsumer>
    </>
  );
}


export default AllKogaRaport;
